import { render, staticRenderFns } from "./StoreParent.vue?vue&type=template&id=4e932372"
import script from "./StoreParent.vue?vue&type=script&lang=js"
export * from "./StoreParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports